<template>
  <v-main :class="(customerId || celebrationId) ? 'pa-0' : ''">
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Faturas</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
          <v-btn text color="primary" @click="modalFilter = true">
            <v-icon left>mdi-filter-outline</v-icon> Filtrar
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'newInvoice', query: queryParams }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Fatura
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'newInvoice', query: { type: 'paid', ...queryParams } }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Valor pago
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text color="primary" :disabled="!itemsSelected || itemsSelected.length === 0">
                <v-icon>mdi-format-list-checks</v-icon> Ações <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :disabled="!renegotiationButtonEnable" @click="modalRenegotiation = true">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-handshake</v-icon> Renegociar</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :disabled="!cancelButtonEnable" @click="modalCancel = true">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-delete</v-icon> Cancelar</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-tooltip bottom :disabled="renegotiationButtonEnable">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn text color="primary" :disabled="!renegotiationButtonEnable" @click="modalRenegotiation = true">
                  <v-icon left>mdi-handshake</v-icon> Renegociar
                </v-btn>
              </div>
            </template>
            <span>{{ renegotiationButtonTooltip }}</span>
          </v-tooltip> -->
        </div>
      </v-toolbar>
      <v-data-table
        v-model="itemsSelected"
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
        :sort-by.sync="pagination.sortBy"
        :sort-desc.sync="pagination.sortDesc"
        item-key="id"
        show-select
      >
        <template v-slot:item.actions="{ item }">
          <div class="no-wrap">
            <v-btn v-if="item.id" @click="copyToClipboard(item.id)" color="primary" fab text small dark>
              <v-icon>mdi-code-tags</v-icon>
            </v-btn>
            <v-btn :to="{ name: 'invoiceDetails', params: { id: item.id } }" color="primary" fab text small dark>
              <v-icon>mdi-file-find</v-icon>
            </v-btn>
            <v-btn v-if="item.invoice_url" :href="item.invoice_url" target="_blank" color="primary" fab text small dark>
              <v-icon>mdi-barcode</v-icon>
            </v-btn>
            <v-btn v-if="item.invoice_status === 'pending' || item.invoice_status === 'late'" :to="{ name: 'updateInvoice', params: { id: item.id } }" color="primary" fab text small dark>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.customer.name="{ item }">
          {{ item.customer.name }}<br>({{ item.customer.nickname }})
        </template>
        <template v-slot:item.customer.person_document="{ item }">
          {{ item.customer.person_document | document }}
        </template>
        <template v-slot:item.customer.phone_number="{ item }">
          {{ item.customer.phone_number | phone_number }}
        </template>
        <template v-slot:item.total_amount="{ item }">
          {{ item.total_amount | price }}
        </template>
        <template v-slot:item.total_without_interest_and_fines="{ item }">
          {{ item.total_amount - item.total_interest_and_fines | price }}
        </template>
        <template v-slot:item.total_interest_and_fines="{ item }">
          {{ item.total_interest_and_fines | price }}
        </template>
        <template v-slot:item.invoice_date="{ item }">
          {{ item.invoice_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.due_date="{ item }">
          {{ item.due_date | moment('DD/MM/YYYY') }}
        </template>
        <template v-slot:item.payment_date="{ item }">
          {{ item.payment_date | moment('DD/MM/YYYY hh:mm') }}
        </template>
        <template v-slot:item.invoice_status="{ item }">
          <v-tooltip v-if="item.notes" bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-chip small :color="invoiceStatusColor(item.invoice_status)">
                  {{ item.invoice_status | invoice_status }}
                </v-chip>
              </div>
            </template>
            <span>{{ item.notes }}</span>
          </v-tooltip>
          <v-chip v-else small :color="invoiceStatusColor(item.invoice_status)">
            {{ item.invoice_status | invoice_status }}
          </v-chip>
        </template>
      </v-data-table>
    </v-container>
    <filter-modal :open="modalFilter" page="invoices" title="Faturas" @close="modalFilter = false"></filter-modal>
    <v-dialog v-model="modalRenegotiation" max-width="400">
      <v-card>
        <v-card-title class="headline">Renegociar Faturas</v-card-title>
        <v-card-text>
          <v-row class="text-right pb-4">
            <v-col>
              <small style="white-space: nowrap">Valor Total</small>
              <br>
              <b>{{ valueSelected.total | price }}</b>
            </v-col>
            <v-col>
              <small style="white-space: nowrap">Multa/juros faturas</small>
              <br>
              <b>{{ valueSelected.interestOthers | price }}</b>
            </v-col>
            <v-col>
              <small style="white-space: nowrap">Multa/juros negociação</small>
              <br>
              <b>{{ valueSelected.interest | price }}</b>
            </v-col>
          </v-row>
          <!-- <v-form v-if="isSuperAdmin" ref="form" @submit.prevent>
            <v-text-field
              label="Em quantas vezes? *"
              v-model="installments"
              :rules="[v => !!v || 'A quantidade de vezes é obrigatória']"
              outlined dense
            ></v-text-field>
            <v-checkbox
              label="Adicionar adiantamento?"
              v-model="addAdvancePayment"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-text-field
              v-if="addAdvancePayment"
              label="Percentual de entrada *"
              v-model.number="advancePaymentPercent"
              :rules="[
                v => !!v || 'O percentual de entrada é obrigatório',
                v => (v >= 0 && v <= 100) || 'O valor deve estar entre 0 e 100'
              ]"
              outlined dense
            ></v-text-field>
            <v-dialog
              ref="dialog"
              v-model="firstInstallmentDateModal"
              :return-value.sync="firstInstallmentDate"
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="firstInstallmentDate ? $moment(firstInstallmentDate, 'YYYY-MM').format('MM/YYYY') : ''"
                  outlined
                  dense
                  label="Quando começa? *"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="firstInstallmentDate"
                scrollable
                :min="this.$moment().format('YYYY-MM')"
                locale="pt-br"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="firstInstallmentDateModal = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(firstInstallmentDate)">Confirmar</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-checkbox
              label="Incluir os juros?"
              v-model="includeTax"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
          </v-form> -->
          <div class="my-3">
            <div class="rounded-borders grey lighten-4 pa-3">
              <div class="pb-2"><b>Boleto ou PIX</b>&nbsp;<span class="caption">(com juros)</span></div>
              Valor: {{ valueSelected.total | price }}
              <br />
              Multa e juros: {{ parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest) | price }}
              <br />
              <b>Total: {{ parseFloat(valueSelected.total) + parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest) | price }}</b>
            </div>
            <!-- <div class="rounded-borders grey lighten-4 pa-3">
              <div class="pb-2"><b>Boleto ou PIX</b>&nbsp;<span class="caption">(com juros)</span></div>
              Valor: {{ valueSelected.total | price }}
              <br />
              Multa e juros: {{ parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest) | price }}
              <br />
              <b>Valor no boleto ou PIX: {{ parseFloat(valueSelected.total) + parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest) | price }}</b>
            </div>
            <br />
            <div class="rounded-borders grey lighten-4 pa-3">
              <div class="pb-2"><b>Cartão</b>&nbsp;<span class="caption">(sem juros + taxa cartão)</span></div>
              <b>Valor no cartão: {{ parseFloat(valueSelected.total) | price }} + taxa do cartão <span class="caption">(calcular usando a planilha)</span></b>
            </div>
            <br />
            <div class="rounded-borders grey lighten-4 pa-3">
              <div class="pb-2">
                <b>50% Boleto ou PIX</b>&nbsp;<span class="caption">(com juros - 50%)</span>
              </div>
              Valor: {{ parseFloat(valueSelected.total) / 2 | price }}
              <br />
              Multa e juros: {{ (parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest)) / 2 | price }}
              <br />
              <b>Valor no boleto ou PIX: {{ (parseFloat(valueSelected.total) / 2) + ((parseFloat(valueSelected.interestOthers) + parseFloat(valueSelected.interest)) / 2) | price }}</b>
              <br /><br />
              <div class="pb-2">
                <b>50% Cartão</b>&nbsp;<span class="caption">(sem juros + taxa cartão)</span>
              </div>
              <b>Valor no cartão: {{ parseFloat(valueSelected.total) - parseFloat((parseFloat(valueSelected.total) / 2).toFixed(2)) | price }} + taxa do cartão <span class="caption">(calcular usando a planilha)</span></b>
            </div> -->
          </div>
          <!-- <p class="mt-5 caption">As informações de renegociação devem ser passadas para a equipe técnica através da ferramenta de chamados.</p> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="modalRenegotiation = false">
            Fechar
          </v-btn>
          <!-- <v-btn v-if="isSuperAdmin"
            color="success"
            :disabled="!installments || !firstInstallmentDate"
            text
            :to="{
              name: 'renegotiationForm',
              query: {
                invoices: selectedInvoices,
                installments,
                includeTax,
                startsAt: firstInstallmentDate,
                ...addAdvancePayment
                ? {
                  advancePaymentPercent: advancePaymentPercent / 100
                }
                : {}
              }
            }"
          >
            Renegociar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalCancel" max-width="500">
      <v-card>
        <v-card-title class="headline">Cancelar {{ itemsSelected.length }} Faturas</v-card-title>
        <v-card-text class="pb-0">
          <v-textarea
            outlined
            label="Motivo do cancelamento *"
            v-model="cancelReason"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" :disabled="canceling" text @click="modalCancel = false">
            Desistir
          </v-btn>
          <v-btn color="error" :disabled="canceling" :loading="canceling" text @click="cancelInvoices()">
            Cancelar Fatura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FilterModal from '@/components/FilterModal'
import Quicksearch from '@/components/Quicksearch'

export default {
  name: 'invoices',
  components: {
    Quicksearch,
    FilterModal
  },
  props: ['customerId', 'celebrationId'],
  data () {
    let customFields

    if (this.customerId && this.celebrationId) {
      customFields = []
    } else if (this.customerId) {
      customFields = [
        {
          text: 'Turma',
          value: 'celebration.name'
        }
      ]
    } else if (this.celebrationId) {
      customFields = [
        {
          text: 'Cliente',
          value: 'customer.name'
        },
        {
          text: 'CPF/CNPJ',
          value: 'customer.person_document',
          sortable: false
        },
        {
          text: 'Telefone',
          value: 'customer.phone_number',
          sortable: false
        }
      ]
    } else {
      customFields = [
        {
          text: 'Turma',
          value: 'celebration.name'
        },
        {
          text: 'Cliente',
          value: 'customer.name'
        },
        {
          text: 'CPF/CNPJ',
          value: 'customer.person_document',
          sortable: false
        },
        {
          text: 'Telefone',
          value: 'customer.phone_number',
          sortable: false
        }
      ]
    }

    return {
      loading: false,
      modalFilter: false,
      quicksearch: '',
      items: [],
      itemsSelected: [],
      modalCancel: false,
      cancelReason: '',
      canceling: false,
      modalRenegotiation: false,
      installments: 0,
      firstInstallmentDate: null,
      firstInstallmentDateModal: false,
      addAdvancePayment: false,
      advancePaymentPercent: 0,
      includeTax: false,
      headers: [
        {
          text: '',
          sortable: false,
          value: 'actions'
        },
        ...customFields,
        {
          text: 'Total',
          value: 'total_amount',
          sortable: false
        },
        {
          text: 'Multa e juros',
          value: 'total_interest_and_fines',
          sortable: false
        },
        {
          text: 'Total sem juros',
          value: 'total_without_interest_and_fines',
          sortable: false
        },
        {
          text: 'Competência',
          value: 'invoice_date'
        },
        {
          text: 'Vencimento',
          value: 'due_date'
        },
        {
          text: 'Pagamento',
          value: 'payment_date'
        },
        {
          text: 'Status',
          value: 'invoice_status'
        }
      ],
      pagination: {
        rowsPerPage: 20,
        page: 1,
        total: 0,
        sortBy: ['invoice_date'],
        sortDesc: []
      }
    }
  },
  computed: {
    ...mapGetters(['searchParams', 'invoiceStatusColor', 'isSuperAdmin', 'user', 'userEmail']),
    noResultText () {
      return 'Nenhuma fatura encontrada'
    },
    queryParams () {
      let queryParams = {}
      if (this.celebrationId) queryParams.celebration = this.celebrationId
      if (this.customerId) queryParams.customer = this.customerId
      return queryParams
    },
    renegotiationButtonTooltip () {
      if (this.itemsSelected.length > 0) {
        if (this.itemsSelected.filter(e => !['pending', 'late'].includes(e.invoice_status)).length > 0) return 'Só é possível renegociar faturas pendentes e atrasadas'
        return 'Só é possível renegociar faturas do mesmo cliente na mesma turma'
      }
      return 'Selecione as faturas que quer renegociar'
    },
    renegotiationButtonEnable () {
      let enable = false
      if (this.itemsSelected.length === 1) enable = true
      else if (this.itemsSelected.length > 1) {
        let celebration, customer
        enable = true
        for (let i in this.itemsSelected) {
          if (!celebration) celebration = this.itemsSelected[i].celebration.id
          else if (this.itemsSelected[i].celebration.id !== celebration) enable = false
          if (!customer) customer = this.itemsSelected[i].customer.id
          else if (this.itemsSelected[i].customer.id !== customer) enable = false
          if (['paid'].includes(this.itemsSelected[i].invoice_status)) enable = false
        }
      }
      return enable
    },
    cancelButtonTooltip () {
      if (this.itemsSelected.length > 0) {
        if (this.itemsSelected.filter(e => !['pending', 'late'].includes(e.invoice_status)).length > 0) return 'Só é possível cancelar faturas pendentes e atrasadas'
        return 'Só é possível cancelar faturas do mesmo cliente na mesma turma'
      }
      return 'Selecione as faturas que quer cancelar'
    },
    cancelButtonEnable () {
      let enable = false
      if (this.itemsSelected.length > 0) {
        enable = true
        for (let i in this.itemsSelected) {
          if (!['pending', 'late'].includes(this.itemsSelected[i].invoice_status)) enable = false
        }
      }
      return enable
    },
    selectedInvoices () {
      return this.itemsSelected.map(e => e.id).join()
    },
    valueSelected () {
      let total = 0
      let interest = 0
      let interestOthers = 0
      for (let item in this.itemsSelected) {
        let totalAmount = this.itemsSelected[item].total_amount - this.itemsSelected[item].total_interest_and_fines
        let days = this.$moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).diff(this.$moment(this.itemsSelected[item].due_date + ' 00:00:00'), 'days')
        let dailyInterest = (days > 0) ? this.itemsSelected[item].celebration.daily_interest * totalAmount / 3000 * days : 0
        let fineForDelay = (days > 0) ? this.itemsSelected[item].celebration.fine_for_delay * totalAmount / 100 : 0
        console.log(totalAmount, days, this.itemsSelected[item].celebration.daily_interest, dailyInterest, this.itemsSelected[item].celebration.fine_for_delay, fineForDelay)
        total = (parseFloat(total) + totalAmount).toFixed(2)
        interestOthers = (parseFloat(interestOthers) + parseFloat(this.itemsSelected[item].total_interest_and_fines)).toFixed(2)
        interest = (parseFloat(interest) + dailyInterest + fineForDelay).toFixed(2)
      }
      return { total, interest, interestOthers }
    },
    params () {
      let params = '?page[size]=' + this.pagination.rowsPerPage + '&page[number]=' + this.pagination.page
      if (this.quicksearch.length > 0) params += '&filter[q]=' + this.quicksearch
      if (this.customerId) params += '&filter[customer_id]=' + this.customerId
      if (this.celebrationId) params += '&filter[celebration_id]=' + this.celebrationId

      for (let key in this.searchParams('invoices')) {
        if (this.searchParams('invoices')[key]) {
          if (Array.isArray(this.searchParams('invoices')[key])) {
            if (this.searchParams('invoices')[key].length > 0 && !this.searchParams('invoices')[key].includes(undefined)) {
              params += '&filter[' + key + ']=' + this.searchParams('invoices')[key].join()
            }
          } else params += '&filter[' + key + ']=' + this.searchParams('invoices')[key]
        }
      }

      const sorts = {
        'celebration.name': 'celebration_name',
        'customer.name': 'customer_name'
      }

      for (let i = 0, l = this.pagination.sortBy.length; i < l; i++) {
        if (i === 0) params += '&sort='
        else params += ','
        if (this.pagination.sortDesc[i]) params += '-'
        params += sorts[this.pagination.sortBy[i]] || this.pagination.sortBy[i]
      }
      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    getData () {
      let vue = this
      vue.items = []
      vue.itemsSelected = []
      vue.loading = true

      axios.get('invoices' + vue.params)
        .then(response => {
          vue.items = response.data.data
          vue.pagination.total = response.data.meta.total
        })
        .catch(() => {
          vue.items = []
          vue.pagination.total = 0
        })
        .finally(() => {
          vue.loading = false
        })
    },
    async cancelInvoices () {
      this.canceling = true
      const dateNow = this.$moment().format('DD/MM/YYYY HH:mm')
      for (const index in this.itemsSelected) {
        if (this.itemsSelected[index].id) {
          await axios.put(`invoices/${this.itemsSelected[index].id}/cancel`, {
            notes: this.cancelReason + ' - ' + this.user + ' (' + this.userEmail + ') - ' + dateNow
          })
        }
      }
      this.SET_SNACKBAR({ text: 'Faturas canceladas' })
      this.modalCancel = false
      this.itemsSelected = []
      this.canceling = false
      this.getData()
    }
  },
  created () {
    this.getData()
  }
}
</script>
